/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Button, Spinner } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useFormik } from 'formik';
import Military from './Military';
import Ethnicity from './Ethnicity';
import Language from './Language';
import {
  getDemoGraphics,
  updateDemoGraphics,
} from 'app/basicInformationSlice/basicInformationSlice';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { formatBoolean, BoolToString, checkEnableParseJSON, tryParseJSON, isEmptyObject } from 'components/helper/helper';
import LoadingContent from 'components/LoadingContent';
import GroupCheckbox from 'components/input/GroupCheckbox';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { debounce } from 'lodash';
import { useLocation } from 'react-router-dom';
import Grid from '@mui/joy/Grid';
import { MilitaryBranch } from './MilitaryConfig';
import { ModalCheckField } from 'screen/common/ModalCheckField';
import SearchIcon from '@mui/icons-material/Search';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

export const militaryOptions = [
  {
    value: 'is_married_or_in_civil_union',
    label: 'I am married or in a civil union/registered domestic partnership',
  },
  {
    value: 'is_have_children',
    label: 'I have children',
  },
  {
    value: 'is_foster_care',
    label: `I've been in foster care or am a ward of the court in the United States`,
  },
  {
    value: 'is_will_be_current_member',
    label: 'When I attend UC, I will be a current or former member of the U.S. military',
  },
  {
    value: 'is_none_above_apply_to_me',
    label: 'None of the above apply to me',
  },
];

const Demographics = () => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [showModalCheckField, setShowModalCheckField] = React.useState(false);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const basicInformationStore = useAppSelector((store) => store.basicInformation);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const [militaryExperience, setMilitaryExperience] = React.useState<MilitaryBranch[]>([]);
  const formik = useFormik({
    initialValues: {
      anticipated_status: '',
      number_military_experience: 0,
      language: '',
      religious_preference: '',
      other_religion: '',
      us_armed_forces_status: '',
      other_religion_language: '',
      is_dependent_us_military: '',
      is_consider_hispanic_latino: '',
      is_complete_satisfaction: false,
      number_language_proficient: 0,
      language_array: [{}],
      is_option_1: false,
      is_option_2: false,
      is_option_3: false,
      is_option_4: false,
      is_central_america: false,
      is_cuba: false,
      is_mexico: false,
      is_puerto_rico: false,
      is_south_america: false,
      is_spain: false,
      is_other_background: false,
      specifyOtherHispanic: '',
      best_group_describe_racial_background_array: {
        csu_reporting_preferences: 'Select',
        racial_background: '',
        racial_background_Asian: '',
        racial_OtherAsian_value: '',
        racial_background_White: '',
        racial_OtherWhite_value: '',
        racial_background_African: '',
        racial_OtherAfrican_value: '',
        racial_background_AmericanIndian: false,
        enrolledMemberOfAmericanIndianOrAlaskaNative: '',
        tribal_enrollment: '',
        is_enrolled_member_of_American_Indian_or_Alaska_Native: '',
        tribal_enrollment_primary: '',
        tribal_citizenship_or_enrollment_number: '',
        tribe_member_of: '',
        specify_tribe_member_of_Other_Alaska_Native: '',
        specify_tribe_member_of_Other_American_Indian: '',
        is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information: false,
        racial_background_more_AfricanAmerican: false,
        racial_background_more_Asian: false,
        racial_background_more_AmericanIndian: false,
        racial_background_more_White: false,
        racial_background_more_NativeHawaiian: false,
        racial_background_white_Europe: false,
        racial_background_white_MiddleEast: false,
        racial_background_white_NorthAfrica: false,
        racial_background_white_Other: false,
        racial_background_identify_AfricanAmerican: false,
        racial_background_identify_NativeHawaiian: false,
        racial_background_identify_White: false,
        racial_background_identify_AmericanIndian: false,
        racial_background_identify_Asian: false,
        racial_background_identify_Southwest_Asian_and_North_African: false,
        racial_AmericanIndia_primary: '',
        racial_AmericanIndia_tribal: '',
        racial_AmericanIndia_tribal_affiliation: '',
        racial_AmericanIndia_is_recognized_tribe: '',
        racial_AmericanIndia_tribe: '',
        racial_AmericanIndia_tribal_number: '',
        is_consent_to_use_for_UC: false,
        cm_tribe_enrolled: '',
        csu_tribe_enrolled: '',
        racial_background_NativeHawaiian: '',
        racial_OtherPacific_value: '',
        racial_Southwest_Asian_and_North_African: '',
        racial_Southwest_Asian_and_North_African_other: '',
        value_consider_hispanic_latino: '',
        is_Argentinean: false,
        is_Bolivian: false,
        is_Chilean: false,
        is_Colombian: false,
        is_Dominican: false,
        is_Ecuadorian: false,
        is_Guatemalan: false,
        is_Honduran: false,
        is_Mexican: false,
        is_Nicaraguan: false,
        is_Panamanian: false,
        is_Paraguayan: false,
        is_Peruvian: false,
        is_Puerto: false,
        is_Salvadoran: false,
        is_Spaniard: false,
        is_Uruguayan: false,
        is_Venezuelan: false,
        is_Other_Central_American: false,
        is_Other_South_American: false,
        is_Other_Hispanic_or_Latino: false,
        specify_is_Other_Central_American: '',
        specify_is_Other_South_American: '',
        specify_is_Other_Hispanic_or_Latino: '',
      },

      is_married_or_in_civil_union: false,
      is_none_above_apply_to_me: true,
      is_have_children: false,
      is_foster_care: false,
      is_will_be_current_member: false,
      is_want_receive_AmericanIndia_support_information: true,

      demographics_additional_data: {
        isInFosterCare: '',
        usMilitaryStatus: '',
        isPermanentlyStationed: '',
        is_US_military_service_permanently_stationed_in_California: false,
        is_US_military_service_on_active_duty: false,
        specify_other_language: '',
        statusOfPersonYouAreDependance: '',
        is_plan_to_submit_us_military_transcript: false,
      },
    },
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        let militaryArr = fixMilitaryBranchArray(militaryExperience);

        const newValues = {
          student_id: parseInt(studentId || ''),
          language: values.language,
          religious_preference: values.religious_preference,
          other_religion: values.other_religion,
          us_armed_forces_status: values.us_armed_forces_status,
          other_religion_language: values.other_religion_language,
          is_dependent_us_military: formatBoolean(values.is_dependent_us_military),
          is_consider_hispanic_latino: formatBoolean(values.is_consider_hispanic_latino),
          is_complete_satisfaction: values.is_complete_satisfaction,
          number_language_proficient: values.number_language_proficient,
          all_apply_array: JSON.stringify({
            is_none_above_apply_to_me: values.is_none_above_apply_to_me,
            is_married_or_in_civil_union: values.is_married_or_in_civil_union,
            is_have_children: values.is_have_children,
            is_foster_care: values.is_foster_care,
            is_will_be_current_member: values.is_will_be_current_member,
            is_want_receive_AmericanIndia_support_information:
              values.is_want_receive_AmericanIndia_support_information,
          }),
          best_group_latino_background_array: JSON.stringify({
            is_central_america: values.is_central_america,
            is_cuba: values.is_cuba,
            is_mexico: values.is_mexico,
            is_puerto_rico: values.is_puerto_rico,
            is_south_america: values.is_south_america,
            is_spain: values.is_spain,
            is_other_background: values.is_other_background,
            specifyOtherHispanic: values.specifyOtherHispanic,
          }),
          best_group_describe_racial_background_array: JSON.stringify(
            values.best_group_describe_racial_background_array
          ),
          language_array: values.language_array,
          military_experience_array: JSON.stringify(militaryArr),
          number_military_experience: values.number_military_experience,
          anticipated_status: values.anticipated_status,
          demographics_additional_data: JSON.stringify(values.demographics_additional_data),
        };
        await dispatch(updateDemoGraphics(newValues));
      } else {
        handleLogout();
      }
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = async () => {
    formik.handleSubmit();
    history.push(routers.citizenship.path);
  };

  const handleCheckMissingFields = () => {
    setShowModalCheckField(true);
  };

  const handleCloseModal = () => {
    setShowModalCheckField(false);
  };

  // Prepare data for modal check
  const getModalData = () => {
    // Ensure best_group_describe_racial_background_array is properly parsed
    let parsedRacialBackground = formik.values.best_group_describe_racial_background_array;
    if (typeof parsedRacialBackground === 'string') {
      try {
        parsedRacialBackground = JSON.parse(parsedRacialBackground);
      } catch (error) {
        console.error('Error parsing best_group_describe_racial_background_array:', error);
      }
    }

    // Ensure demographics_additional_data is properly parsed
    let parsedDemographicsAdditional = formik.values.demographics_additional_data;
    if (typeof parsedDemographicsAdditional === 'string') {
      try {
        parsedDemographicsAdditional = JSON.parse(parsedDemographicsAdditional);
      } catch (error) {
        console.error('Error parsing demographics_additional_data:', error);
      }
    }

    return {
      ...formik.values,
      militaryExperience: militaryExperience,
      language_array: checkEnableParseJSON(formik.values.language_array), 
      best_group_describe_racial_background_array: parsedRacialBackground,
      demographics_additional_data: parsedDemographicsAdditional,
    };
  };

  const checkFirstLanguage = (lang: any[]) => {
    if (lang && lang.length > 0) {
      if (lang[0].isFirstLanguage === false) return false;

      if (lang.length > 1) {
        for (var i = 1; i < lang.length; i++) {
          if (lang[i].isFirstLanguage === true) return false;
        }
      }
      return true;
    }
    return false;
  };
  const fixFirstLanguage = (lang: any[]) => {
    if (lang && lang.length > 0) {
      lang[0].isFirstLanguage = true;
      if (lang.length > 1) {
        for (var i = 1; i < lang.length; i++) {
          lang[i].isFirstLanguage = false;
        }
      }
    }
  };

  const fixMilitaryBranchArray = (arr: MilitaryBranch[]) => {
    if (arr && arr.length>0) {
      for(var i=0; i< arr.length; i++) {
        let item:any = arr[i];
        if (isEmptyObject(item)) {
          const newArray = [...arr];
          newArray.splice(i, 1, {
            branch: '',
            startDate: '',
            endDate: '',
          });
          return newArray;
        }
      }
    }
    return arr;
  }

  const [languageArray, setLanguageArray] = React.useState<any[]>([]);
  
  // Sync languageArray state with formik values when formik values change
  // React.useEffect(() => {
  //   console.log('formik.values.language_array', formik.values.language_array);
  //   if (formik.values.language_array) {
  //     try {
  //       const parsedLanguageArray = typeof formik.values.language_array === 'string' 
  //         ? JSON.parse(formik.values.language_array) 
  //         : formik.values.language_array;

      
  //       setLanguageArray(parsedLanguageArray);
  //     } catch (error) {
  //       console.error('Error parsing language_array:', error);
  //     }
  //   }
  // }, [formik.values.language_array]);

  React.useEffect(() => {
    const getData = async () => {
    const pageStatus: any = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.DEMOGRAPHICS);
    setReviewedAndComplete(pageStatus.student_completed);
    }
    getData();
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      try {
        setLoading(true);

        dispatch(getDemoGraphics(studentId)).then((res: any) => {
          if (!res.payload) {
            setLoading(false);
          } else {
            const all_apply_array = checkEnableParseJSON(res.payload.all_apply_array);
            const best_option_latino_backgroud_array = checkEnableParseJSON(
              res.payload.best_option_latino_backgroud_array
            );
            const best_group_latino_background_array = checkEnableParseJSON(
              res.payload.best_group_latino_background_array
            );
            const parsedLanguageArray = checkEnableParseJSON(res.payload.language_array);
            const language_array = Array.isArray(parsedLanguageArray) ? parsedLanguageArray : [{}];

            let fixLang = !checkFirstLanguage(language_array);
            if (fixLang) {
              fixFirstLanguage(language_array);
            }
            setLanguageArray(language_array);

            let military_experience_array:MilitaryBranch[] = tryParseJSON(res.payload.military_experience_array) ?? [];
            military_experience_array = fixMilitaryBranchArray(military_experience_array);
            setMilitaryExperience(military_experience_array);

            const values = {
              ...res.payload,
              best_group_describe_racial_background_array: {
                ...formik.values.best_group_describe_racial_background_array,
                ...checkEnableParseJSON(res.payload.best_group_describe_racial_background_array),
              },
              demographics_additional_data: checkEnableParseJSON(
                res.payload.demographics_additional_data
              ),
              is_dependent_us_military: BoolToString(res.payload.is_dependent_us_military),
              is_consider_hispanic_latino: BoolToString(res.payload.is_consider_hispanic_latino),
              number_language_proficient:
                Number(res.payload.number_language_proficient) !== language_array.length
                  ? language_array.length
                  : res.payload.number_language_proficient,
              ...all_apply_array,
              ...best_option_latino_backgroud_array,
              ...best_group_latino_background_array,
              language_array: language_array,
            };
            formik.resetForm({ values: { ...formik.values, ...values } });
            setLoading(false);

            if (fixLang) {
              //checkFirstLanguage is false => run autoSave to fix Data
              formik.handleSubmit();
            }
          }
        });
      } catch (ex) {
        console.log('Error at getDemoGraphics(): ', ex);
      }
    } else {
      handleLogout();
    }
  }, []);

  const checkNoneApply = (e: boolean) => {
    if (e) {
      formik.setFieldValue('is_will_be_current_member', false);
      formik.setFieldValue('is_foster_care', false);
      formik.setFieldValue('is_have_children', false);
      formik.setFieldValue('is_married_or_in_civil_union', false);
    }
  };
  const checkOtherThanNoneApply = (e: boolean) => {
    if (e) {
      formik.setFieldValue('is_none_above_apply_to_me', false);
      return;
    } else if (
      [
        formik.values.is_will_be_current_member,
        formik.values.is_foster_care,
        formik.values.is_have_children,
        formik.values.is_married_or_in_civil_union,
      ].filter((i) => i === true).length <= 1
    ) {
      formik.setFieldValue('is_none_above_apply_to_me', true);
    }
  };
  // Auto save function ==========
  React.useEffect(() => {
    debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  // Auto save function ==========

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.DEMOGRAPHICS, reviewedAndComplete, setReviewedAndComplete);
  }

  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'Military', percentOnProcess: 30 },
          { title: 'Ethnicity', percentOnProcess: 60 },
          { title: 'Language', percentOnProcess: 90 },
        ]}
        title="Demographics"
        process={1}
        icon={<PersonOutlineOutlinedIcon />}
        isMobile={isMobile}
      />
      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div id="Military" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Demographics
              </span>
            </div>
            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <div className={`bg-white card ${isMobile ? 'p-mobile-2' : 'p-3'}`} style={{ 
                marginBottom: isMobile ? '16px' : '32px',
                borderRadius: isMobile ? '12px' : '8px',
                boxShadow: isMobile ? '0 2px 8px rgba(0,0,0,0.1)' : undefined
              }}>
                <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                  <Grid xs={12}>
                    <GroupCheckbox
                      columns={1}
                      label="Check any of the following that apply to you: *"
                      dataUp="demo-apply-to-you"
                      options={[
                        {
                          onChecked: checkOtherThanNoneApply,
                          value: 'is_married_or_in_civil_union',
                          label: 'I am married or in a civil union/registered domestic partnership',
                          disabled: reviewedAndComplete,
                        },
                        {
                          onChecked: checkOtherThanNoneApply,
                          value: 'is_have_children',
                          label: 'I have children',
                          disabled: reviewedAndComplete,
                        },
                        {
                          onChecked: checkOtherThanNoneApply,
                          value: 'is_foster_care',
                          label: `I've been in foster care or am a ward of the court in the United States`,
                          disabled: reviewedAndComplete,
                          subContent: formik.values.is_foster_care ? (
                            <Grid xs={12}>
                              <YesNoSwitch
                                className="uc-flag"
                                label="Are you a ward of the court or in foster care in California? *"
                                name="demographics_additional_data.isInFosterCare"
                                onChange={formik.handleChange}
                                values={formik.values.demographics_additional_data?.isInFosterCare}
                                disabled={reviewedAndComplete}
                                isMissing={
                                  !formik.values.demographics_additional_data?.isInFosterCare && check
                                    ? true
                                    : false
                                }
                              />
                            </Grid>
                          ) : null,
                        },
                        {
                          onChecked: checkOtherThanNoneApply,
                          value: 'is_will_be_current_member',
                          label:
                            'When I attend UC, I will be a current or former member of the U.S. military',
                          disabled: reviewedAndComplete,
                        },
                        {
                          value: 'is_none_above_apply_to_me',
                          label: 'None of the above apply to me',
                          onChecked: checkNoneApply,
                          disabled: reviewedAndComplete,
                        },
                      ]}
                      form={formik}
                      isMissing={
                        !formik.values?.is_foster_care &&
                        !formik.values?.is_have_children &&
                        !formik.values?.is_married_or_in_civil_union &&
                        !formik.values?.is_none_above_apply_to_me &&
                        !formik.values?.is_will_be_current_member &&
                        check
                          ? true
                          : false
                      }
                    />
                  </Grid>
                </Grid>
              </div>
              <div className={`bg-white card ${isMobile ? 'my-2 p-mobile-2' : 'my-3 p-3'}`} style={{
                borderRadius: isMobile ? '12px' : '8px',
                boxShadow: isMobile ? '0 2px 8px rgba(0,0,0,0.1)' : undefined
              }}>
                <Grid xs={12}>
                  <Military
                    formik={formik}
                    militaryExperience={militaryExperience}
                    setMilitaryExperience={setMilitaryExperience}
                    check={check}
                    isMobile={isMobile}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
              </div>
            </div>

            <div id="Ethnicity" className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <Ethnicity formik={formik} check={check} isMobile={isMobile} disabled={reviewedAndComplete} />
                </Grid>
              </Grid>
            </div>
            <div id="Language" className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <Language formik={formik} languageArray={languageArray} check={check} isMobile={isMobile} disabled={reviewedAndComplete} />
                </Grid>
              </Grid>
            </div>

            <div className={`gm-form-actions border-top ${isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {basicInformationStore.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <ModalCheckField
        show={showModalCheckField}
        onClose={handleCloseModal}
        data={getModalData()}
        page="demographics"
      />
      </Container>
    </>
  );
};

export default Demographics;
